/**
 * Toggles amounts for donations / extra funds for subscriptions.
 */

import { Controller } from "stimulus"

export default class extends Controller {

  static targets = ["custom", "form"];

  connect() {
    this.element.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        this.useAnchor();
        this.updateAmount();
      });
    });

    this.updateAmount();
  }

  useCustom() {
    this.element.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.checked = false;
    });
    if (this.customTarget.value === "") {
      this.customTarget.value = this.customTarget.min;
    }
  }

  useAnchor() {
    this.customTarget.value = "";
  }

  currentValue() {
    const radio = this.element.querySelector("input[type='radio']:checked");
    const value = radio ? radio.value : Math.round(this.customTarget.value * 100);
    if (value > 0) {
      return value;
    }
  }

  updateAmount() {
    const amount = parseInt(this.currentValue()) || 0;

    // The payment form charges this amount when it prepares the payment
    this.formTarget.dataset.stripePaymentAmountValue = amount;

    // Update the payment request client side so the right amount displays
    if (window.paymentRequest && amount > 0) {
      window.paymentRequest.update({
        total: {
          label: "Total",
          amount: amount
        }
      });
    }
  }
}
